import { SAGA_ACTIONS } from "src/_config";
import {
  GetEventList,
  GetEventGameList,
  GetEventGameDetails,
  GetUpcomingEventList,
  JoinEventGame,
  LeaderBoard,
  TvImageDetails,
  SaveVote,
  GameDetailsReq,
  PerformanceListReq,
  MostPopularPicksReq,
} from "src/_common/interfaces/ApiReqRes";
import { useApiCall } from "../common/appApiCallHook";

export function useEventApi() {
  const callApi = useApiCall();

  const eventList = (data: GetEventList, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.GET_EVENT_LIST, data, onSuccess, onError);
  };

  const getPastEventList = (data: GetEventList, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.GET_PAST_EVENT_LIST, data, onSuccess, onError);
  };

  const eventGameList = (data: GetEventGameList, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.GET_EVENT_GAME, data, onSuccess, onError);
  };

  const eventGameDetails = (data: GetEventGameDetails, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.GET_EVENT_GAME_DETAILS, data, onSuccess, onError);
  };

  const upcomingEventList = (data: GetUpcomingEventList, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.GET_UPCOMING_EVENT, data, onSuccess, onError);
  };

  const pickOption = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.PICK_OPTION, data, onSuccess, onError);
  };

  const viewLeaderBoard = (data: LeaderBoard, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.LEADERBOARD, data, onSuccess, onError);
  };

  const joinEventGame = (data: JoinEventGame, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.JOIN_EVENT_GAME, data, onSuccess, onError);
  };

  const tvImageList = (data: TvImageDetails, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.TV_IMAGE.DETAILS, data, onSuccess, onError, false);
  };

  const saveVote = (data: SaveVote, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.SAVE_VOTE, data, onSuccess, onError);
  };

  const getGameDetails = (data: GameDetailsReq, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.GET_GAME_DETAILS, data, onSuccess, onError);
  };

  const prizeDetails = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.PRIZE_DETAILS, data, onSuccess, onError);
  };

  const getRodeoEventGeoLocations = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.GET_RODEO_EVENT_GEO_LOCATIONS, data, onSuccess, onError);
  };

  const getLeaderboardLocationList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.LEADERBOARD_LOCATION_LIST, data, onSuccess, onError);
  };

  const performanceList = (data: PerformanceListReq, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.PERFORMANCE_LIST, data, onSuccess, onError);
  };

  const winningTicketResults = (data: PerformanceListReq, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.WINNING_TICKET_RESULTS, data, onSuccess, onError);
  };

  const getMyTeam = (data: PerformanceListReq, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.GET_MY_TEAM, data, onSuccess, onError);
  };

  const mostPopularPicks = (data: MostPopularPicksReq, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.MOST_POPULAR_PICKS, data, onSuccess, onError);
  };

  const getShareImageLink = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.GET_SHARE_IMAGE_LINK, data, onSuccess, onError);
  };

  const yourPicks = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.YOUR_PICKS, data, onSuccess, onError);
  };

  const getGameStatusText = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.GET_GAME_STATUS_TEXT, data, onSuccess, onError);
  };

  const saveLeagueCode = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.SAVE_LEAGUE_CODE, data, onSuccess, onError);
  };

  const getLeagueLeaderboard = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.LEAGUE_LEADERBOARD, data, onSuccess, onError);
  };

  const getVsLeagueLeaderboard = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.VS_LEAGUE_LEADERBOARD, data, onSuccess, onError);
  };

  const getGallery = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.GET_GALLERY, data, onSuccess, onError);
  };

  const saveTieBreakerCode = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.SAVE_TIEBREAKER_CODE, data, onSuccess, onError);
  };

  const getChallengeList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.GET_CHALLENGE_LIST, data, onSuccess, onError);
  };

  const getChallengeDetails = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.GET_CHALLENGE_DETAILS, data, onSuccess, onError);
  };

  const createChallenge = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.CREATE_CHALLENGE, data, onSuccess, onError);
  };

  const joinChallenge = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.JOIN_CHALLENGE, data, onSuccess, onError);
  };

  const withdrawChallenge = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.EVENT.WITHDRAW_CHALLENGE, data, onSuccess, onError);
  };

  return {
    callGetEventList: eventList,
    callGetUpcomingEventList: upcomingEventList,
    callGetEventGameList: eventGameList,
    callGetEventGameDetails: eventGameDetails,
    callPickOption: pickOption,
    callViewLeaderBoard: viewLeaderBoard,
    callTvImageDetails: tvImageList,
    callJoinEventGame: joinEventGame,
    callSaveVote: saveVote,
    callGetGameDetails: getGameDetails,
    callPrizeDetails: prizeDetails,
    callGetRodeoEventGeoLocations: getRodeoEventGeoLocations,
    callGetLeaderboardLocationList: getLeaderboardLocationList,
    callPerformanceList: performanceList,
    callWinningTicketResults: winningTicketResults,
    callGetMyTeam: getMyTeam,
    callMostPopularPicks: mostPopularPicks,
    callGetShareImageLink: getShareImageLink,
    callYourPicks: yourPicks,
    callGetGameStatusText: getGameStatusText,
    callSaveLeagueCode: saveLeagueCode,
    callGetLeagueLeaderboard: getLeagueLeaderboard,
    callGetVsLeagueLeaderboard: getVsLeagueLeaderboard,
    callGetGallery: getGallery,
    callSaveTieBreakerCode: saveTieBreakerCode,
    callGetPastEventList: getPastEventList,
    callGetChallengeList: getChallengeList,
    callGetChallengeDetails: getChallengeDetails,
    callCreateChallenge: createChallenge,
    callJoinChallenge: joinChallenge,
    callWithdrawChallenge: withdrawChallenge,
  };
}
